/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import Button from "../../../component/button";
import BusApiCall from "../../../helper/axios.js";
import Loader from "../../../component/loader";
import { connect } from "react-redux";
import HeaderNoAuth from "../../../component/header/headerNoAuth";
import actionTypes from "../../../store/actions";
import constants from "../../../helper/constants";
import classes2 from "../apiPortal/apiPortal.module.css";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import Input from "../../../component/inputpm";
import classes from "../../pm/createPackage/createPackage.module.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import classes3 from "../documentation/documentation.module.css";

class Registration extends Component {
  state = {
    loading: false,
    requestor: "",
    companyName: "",
    productManager: "",
    email: "",
    errorMessage: "",

    open: false,
  };

  componentDidMount() {}

  handleClose = () => {
    this.setState({
      open: false,
      requestor: "",
      companyName: "",
      productManager: "",
      email: "",
      errorMessage: "",
    });
  };

  requestRegistration = (data) => {
    this.props.setErrorMessage("", false);

    if (
      !data.requestor ||
      !data.productManager ||
      !data.companyName ||
      !data.email
    ) {
      this.setState({
        errorMessage: "Please fill all required fields (marked by *)",
        open: true,
      });
    } else if (!this.validateEmail(data.email)) {
      this.setState({
        errorMessage: "Invalid Email. Enter a valid email address",
        open: true,
      });
    } else {
      this.setState({ errorMessage: "", open: false });
      BusApiCall(
        "POST",
        `${constants.apiPortalRegistrationUrl}/apiPortalRegistration`,
        this.state,
      )
        .then((res) => {
          this.setState({
            errorMessage: "Registration Request sent successfully.",
            open: true,
          });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage("Something went wrong", false);
          }
        });
      this.setState({ errorMessage: "", open: false });
    }
  };

  validateEmail = (mail) => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
  };

  registrationData = (e) => {
    this.props.setCompDidMount();
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  render() {
    const { registrationData } = this;
    return (
      <React.Fragment>
        <HeaderNoAuth />
        <main style={{ maxWidth: "initial" }}>
          <Grid container>
            <Grid
              item
              size={{
                xs: 2,
                md: 1,
              }}
            >
              <ul className={classes2.leftNavigation}>
                <li>
                  {" "}
                  <Link to="/api-portal"> API Portal </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/api-read-only"> API Reference </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link className={classes2.selected} to="/registration">
                    {" "}
                    Developer Registration{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/sdk"> API SDKs </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/api-ref"> Try Out API </Link>{" "}
                </li>
                {/*<li> <Link to='/internal-api'> Internal API </Link> </li>*/}
              </ul>
            </Grid>
            <Grid
              item
              size={{
                xs: 1,
                md: 1,
              }}
            ></Grid>
            <Grid
              item
              size={{
                xs: 9,
                md: 10,
              }}
            >
              <h1 className={classes3.heading}>
                {" "}
                Cumulator IoT Registration Request
              </h1>

              <p className={classes3.normalText}>
                In order to get access to the API, Developer must
                <ul>
                  <li className={classes3.normalText}>
                    {" "}
                    Work with a Cumulator Product Manager to setup their
                    Products in Catalog
                  </li>
                  <li className={classes3.normalText}>
                    {" "}
                    Register to create an account in Cumulator{" "}
                  </li>
                </ul>
                Once registered, Developer may use the API SDK or directly
                access the REST API with their credentials to integrate their
                application with Cumulator functions and services.
              </p>

              <Grid container direction={"column"} spacing={2}>
                <Grid
                  item
                  size={{
                    xs: 6,
                  }}
                >
                  <Input
                    divClass={classes.customDiv}
                    name={"requestor"}
                    value={this.state.requestor}
                    onChange={(event) => registrationData(event)}
                    placeholder={"Your Name *"}
                    variant={"outlined"}
                    size={"small"}
                  />
                </Grid>

                <Grid
                  item
                  size={{
                    xs: 6,
                  }}
                >
                  <Input
                    divClass={classes.customDiv}
                    name={"companyName"}
                    value={this.state.companyName}
                    onChange={(event) => registrationData(event)}
                    placeholder={"Company Name  *"}
                    variant={"outlined"}
                    size={"small"}
                  />
                </Grid>

                <Grid
                  item
                  size={{
                    xs: 6,
                  }}
                >
                  <Input
                    divClass={classes.customDiv}
                    name={"productManager"}
                    value={this.state.productManager}
                    onChange={(event) => registrationData(event)}
                    placeholder={"Digitize Things Product Manager *"}
                    variant={"outlined"}
                    size={"small"}
                  />
                </Grid>

                <Grid
                  item
                  size={{
                    xs: 6,
                  }}
                >
                  <Input
                    divClass={classes.customDiv}
                    name={"email"}
                    value={this.state.email}
                    onChange={(event) => registrationData(event)}
                    placeholder={"Your Email  *"}
                    variant={"outlined"}
                    size={"small"}
                  />
                </Grid>

                {/*<Grid item xs={6} >*/}
                {/*    <Input divClass={classes.customDiv}*/}
                {/*name={'dcpUserId'}*/}
                {/*value={this.state.dcpUserId}*/}
                {/*onChange={event => registrationData(event)}*/}

                {/*placeholder={'DCP User Name  *'}*/}
                {/*variant={'outlined'}*/}
                {/*size={'small'} />*/}
                {/*</Grid>*/}

                <Grid
                  item
                  size={{
                    xs: 8,
                  }}
                >
                  <label style={mandatoryMessage}>
                    Fields marked with asterick (*) are mandatory.
                  </label>
                </Grid>

                <Grid
                  item
                  className={classes.createPartnerGrid}
                  size={{
                    xs: 4,
                  }}
                >
                  <Button
                    onClick={() => {
                      this.requestRegistration(this.state);
                    }}
                  >
                    Request Registration
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Loader loading={this.state.loading} />
          <Dialog disableScrollLock={true} open={this.state.open}>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {this.state.errorMessage}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  this.handleClose();
                }}
                className={classes.buttonClass}
              >
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </main>
      </React.Fragment>
    );
  }
}

const mandatoryMessage = {
  color: "#f44336",
  fontSize: "12px",
  lineHeight: "64px",
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Registration);
